import React from 'react';
import Button from '../Button';
import BaseModal from './BaseModal';

interface IProps {
    hide(): void;
    placeName: string;
    selectedDate: Date;
    onConfirm(selectedDate: Date): void;
}

const ConfirmSearchModal: React.FC<IProps> = (props) => {
    const handleConfirm = (event: React.SyntheticEvent) => {
        event.preventDefault();
        props.onConfirm(props.selectedDate);
        props.hide();
    }

    const renderContent = () => (
       <div>
           <span className="block pt-3 pb-2">Search <strong>"{props.placeName}"</strong>?</span>
           <small className="block pb-3">Search will run on background, you will be notified once results are ready</small>
           <Button text="Confirm" width="w-full" onClick={handleConfirm} />
       </div>
    );

    return <BaseModal hide={props.hide} header="Confirm Search" content={renderContent()} />
}

export default ConfirmSearchModal;
